/**
 * Атрибут на <html>: вместо упавшего приложения показан снимок серверной разметки.
 */
export const APP_DEGRADED_ATTRIBUTE = 'data-app-degraded';
